import { memo, useEffect, useMemo } from 'react'
import { useCompanyPlanningRecordDialog } from '../../providers/CompanyPlanningRecordDialogProvider'
import { store } from '../../../redux/store'
import authSelectors from '../../../redux/modules/auth/selectors'
import { useParams } from 'react-router-dom'

const CompanyPlanningRecordPage = () => {
  const { companyPlanningRecordId } = useParams<{ companyPlanningRecordId: string }>()
  const combinedCompanyPlanningRecordId = useMemo(() => {
    const companyId = authSelectors.getCompanyId(store.getState())
    const prefix = `${companyId}_`
    if (companyPlanningRecordId?.startsWith(prefix)) {
      return companyPlanningRecordId
    }
    return `${prefix}${companyPlanningRecordId}`
  }, [companyPlanningRecordId])
  const { openCompanyPlanningRecordDialog, closeCompanyPlanningRecordDialog } =
    useCompanyPlanningRecordDialog({
      companyPlanningRecordId: combinedCompanyPlanningRecordId,
    })
  useEffect(() => {
    openCompanyPlanningRecordDialog()
    return () => {
      closeCompanyPlanningRecordDialog()
    }
  })
  return null
}

export default memo(CompanyPlanningRecordPage)
